The postal code of the address.

This field has a maximum length of 50 characters.
